module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/工作站-技术优势1.37947e4d.png";